import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocale } from "@/hooks/useLocale";
import { localizedPath } from "@/i18n/languages";

export default function NotFound() {
  const { t } = useTranslation();
  const lang = useLocale();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-700">
        <i className="ri-error-warning-line text-4xl" />
      </span>
      <h1 className="mt-6 font-heading text-3xl font-semibold text-foreground-950 md:text-5xl">
        {t("notFound.title")}
      </h1>
      <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600 md:text-base">
        {t("notFound.subtitle")}
      </p>
      <Link
        to={localizedPath(lang, "/")}
        className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
      >
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-arrow-left-line text-base" />
        </span>
        {t("article.backHome")}
      </Link>
    </div>
  );
}